import React, { useState, useEffect } from "react";
import {
  Card, CardContent, Typography, Grid, Box
} from "@mui/material";
import axios from "axios";
import utils from "../../utils";

const Dashboard = () => {
  const [data, setData] = useState({
    dipendenti: 0,
    presenze: 0,
    timbrature: 0,
    paghe: 0,
    malattia: 0,
    cassa: 0,
  });

  useEffect(() => {
    const loadStats = async () => {
      try {
        const res = await axios.get(`/api/paghestatscli`, {
          headers: utils.getAuthHeaders(),
        });
        const { success } = res.data;
        if (success) {
          setData(res.data.stats);
        }
      } catch (error) {
        console.log(error);
      }
    };

    loadStats();
  }, []);

  const renderStatCard = (title, value) => {

    return (
      <Card
        variant="outlined"
        sx={{
          borderRadius: '16px',
          boxShadow: 3,
          transition: '0.3s',
          height: '100%',
          '&:hover': {
            boxShadow: 6,
            transform: 'translateY(-4px)'
          }
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h6" color="textSecondary" gutterBottom>{title}</Typography>
          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>{value}</Typography>
        </CardContent>
      </Card>
    );
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      <Box sx={{ mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            {renderStatCard("Dipendenti", data.dipendenti)}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            {renderStatCard("Presenze", data.presenze)}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            {renderStatCard("Timbrature", data.timbrature)}
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            {renderStatCard("Buste Paga", data.paghe)}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            {renderStatCard("Malattia", data.malattia)}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            {renderStatCard("Cassa Integrazione", data.cassa)}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;
